export const PARTICIPANT_MAIN_ROLE = 'owner';
export const CO_OWNER = 'co-owner';
export const MAIN_DRIVER_ROLE = 'driver';
export const USER = 'user';
export const ADDITIONAL_ROLES = [CO_OWNER, USER];
export const POLICY_HOLDER = 'policy_holder';

